import { ApiProduct } from '../../../../services/eaptekaApi/methods/cartGet/types';
import { serializeUnitQuantity } from '../serializeUnitQuantity';
import {
  serializeProductDelivery,
  serializeProductIngredient,
  serializeProductPickup,
  serializeProductPromotion,
  serializeProductVendor
} from '../product';
import { ProductWithAnalytics } from '../../../products/types';
import { serializePrice } from '../serializePrice';

export const serializeProductFromApi = (
  raw: ApiProduct
): ProductWithAnalytics => {
  return {
    id: raw.id,
    sku: raw.sku,
    name: raw.name,
    isDelayed: null,
    unitQuantity: serializeUnitQuantity(raw.unitQuantity),
    preorderDate: raw.preorderDate,
    picture: raw.picture,
    vendor: serializeProductVendor(raw.vendor),
    country: raw.country,
    ingredient: serializeProductIngredient(raw.ingredient),
    isExpired: raw.isExpired,
    availableCount: raw.availableCount,
    delivery: serializeProductDelivery(raw.delivery),
    pickup: serializeProductPickup(raw.pickup),
    eRecipeNumber: raw.eRecipeNumber,
    promotion: raw.promotion.map((p) =>
      serializeProductPromotion(p)
    ),
    isPku: raw.isPku,
    recipeOnly: raw.recipeOnly,
    hasAlcohol: raw.hasAlcohol,
    isVmt: raw.isVmt,
    isStm: raw.isStm,
    forDeletion: false,
    brandName: raw.brandName,
    category: raw.category,
    price: serializePrice(raw.price),
    quantity: raw.quantity,
    daysToPickup: raw.daysToPickup,
    discount: raw.discount,
    recipeSource: raw.recipeSource
  } as ProductWithAnalytics;
};
